import React, { useEffect } from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import logo from "../assets/logocolor.svg";
import mainimg from "../assets/imagenrentableinversorhome2.png";
import { Link } from "react-router-dom";
import Footer from "../component/Footer";
import res1 from "../assets/reslateral1.jpeg";
import res2 from "../assets/reslateral2.jpeg";
import res3 from "../assets/rescentral.jpeg";
import res4 from "../assets/reslateral3.jpg";
import res5 from "../assets/reslateral4.jpeg";
import { FaEnvelope, FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";

const Home = () => {
  useEffect(() => {
    const id = localStorage.getItem("scrollTo");
    if (id) {
      let elem = document.getElementById(id.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
      // Limpia el ID de la sección del almacenamiento local
      localStorage.removeItem("scrollTo");
    }
  }, []);

  return (
    <div class="main">
      <FloatingWhatsApp
        phoneNumber="+5492236879502" // El número de teléfono al que se enviará el mensaje
        accountName="Rentable Inversor" // El nombre de la empresa o persona que ofrece el servicio
        statusMessage="Te responderé en menos de 24 horas" // El texto que indica el tiempo de respuesta
        chatMessage="Hola 👋 ¿te puedo ayudar en algo?" // El mensaje predeterminado que se mostrará en el chat
        placeholder="Escribe un mensaje" // El texto del campo de entrada
        darkMode={false} // El modo oscuro del botón y el chat
        avatar={logo} // La imagen del avatar
        chatboxStyle={{ boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }} // El estilo del chat
      />
      <div class="main_platform_block my-0 mx-auto flex flex-col sm:flex-row justify-center max-w-[1240px] mt-[size-of-navbar] sm:mt-0">
        <div class="max-w-[700px]">
          <img
            alt="https://qxbroker.com/site/img/main/platform.png"
            class="main_image max-w-50% w-full md:relative top-[40px] lg:left-[-100px] xl:left-[-100px] object-scale-down"
            src={mainimg}
          />
        </div>
        <div class="main_platform_container relative sm:right-[60px] sm:top-[120px] max-w-[500px] w-full pl-6 sm:pl-0">
          <h1 class="main_text font-bold text-white md:text-[42px] lg:text-[42px] xl:text-[42px] 2xl:text-[42px] mb-[22px] mr-[24px] leading-[56px] tracking-tight">
            Familia y Comunidad
            <br />
            Rentable Inversor
          </h1>
          <span class="main_subtext text-white/60 md:text-[24px] lg:text-[24px] xl:text-[24px] 2xl:text-[24px] leading-[36px] mr-[24px] mb-[4px]">
            Master Trader en Binarias. Top 1🥇
            <br />
            Determinate, Enfocate, Educate, Despega, Vive Millonario 📈📉
            <br />
            No gastes más tu dinero donde no valoran tu esfuerzo 🏆
          </span>
          <div>
            <Link to="/clases1">
              <button class="btn bg-btngreen rounded-lg p-18 text-white font-bold text-base ml-auto py-5 px-14 ml-auto shadow-btn-shadow shadow-btngreen/25 mt-10 transition duration-300 ease-in-out hover:shadow hover:shadow-btngreen/50 hover:bg-green-700">
                Ver clases
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div class="contenido_section bg-primary py-12 px-4">
        <div class="flex flex-col items-center justify-center mb-14">
          <h2 class="text-white text-center text-4xl font-bold text-gray-800 mb-2">
            Contenido
          </h2>
          <svg
            className="w-16 h-16 text-blue-500 inline-block mr-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M9 15a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm3.8-1.9c.3-.5.7-1 1.2-1.2a1 1 0 0 1 2 0c.5.1.8.4 1.1.7a1 1 0 1 1-1.4 1.4l-.4-.2h-.1a.4.4 0 0 0-.4 0l.4.3a3 3 0 0 1 1.5.9 2 2 0 0 1 .5 1.9c-.3.5-.7 1-1.2 1.2a1 1 0 0 1-2 0c-.4 0-.8-.3-1.2-.7a1 1 0 1 1 1.6-1.3l.3.2h.1a.4.4 0 0 0 .4 0 1 1 0 0 0-.4-.3 3 3 0 0 1-1.5-.9 2 2 0 0 1-.5-2Zm2 .6Zm.5 2.6ZM4 14c.6 0 1 .4 1 1v4a1 1 0 1 1-2 0v-4c0-.6.4-1 1-1Zm3-2c.6 0 1 .4 1 1v6a1 1 0 1 1-2 0v-6c0-.6.4-1 1-1Zm6.5-8c0-.6.4-1 1-1H18c.6 0 1 .4 1 1v3a1 1 0 1 1-2 0v-.8l-2.3 2a1 1 0 0 1-1.3.1l-2.9-2-3.9 3a1 1 0 1 1-1.2-1.6l4.5-3.5a1 1 0 0 1 1.2 0l2.8 2L15.3 5h-.8a1 1 0 0 1-1-1Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="max-w-[1240px] mx-auto">
          <div class="contenido_item bg-black/10 p-4 rounded-lg flex flex-col items-start">
            <h2 class="text-white text-center text-3xl font-bold text-gray-800 mb-2">
              Breve resumen de los contenidos
            </h2>
            <div class="flex flex-col text-gray-400 font-bold">
              <div class="flex items-center mb-4 gap-4">
                <svg
                  className="w-10 h-10 text-blue-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  <span className="font-[900]">
                    Aprende a invertir en opciones binarias
                  </span>
                  , un tipo de producto financiero de alto riesgo y alta
                  rentabilidad, que consiste en predecir si el precio de un
                  activo subirá o bajará en un periodo de tiempo determinado.
                </span>
              </div>
              <div class="flex items-center mb-4 gap-4">
                <svg
                  className="w-10 h-10 text-blue-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  <span className="font-[900]">
                    Conoce las mejores plataformas y brokers
                  </span>{" "}
                  para operar con opciones binarias, que te ofrecen seguridad,
                  transparencia y buen servicio al cliente. Aprende a depositar
                  y retirar dinero de forma segura y rápida.
                </span>
              </div>
              <div class="flex items-center mb-4 gap-4">
                <svg
                  className="w-10 h-10 text-blue-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  <span className="font-[900]">
                    Domina las estrategias más efectivas
                  </span>{" "}
                  para acertar en tus operaciones, desde las más básicas hasta
                  las más avanzadas y exclusivas. Accede a sesiones en vivo
                  donde podrás ver cómo operan los expertos y copiar sus
                  operaciones.
                </span>
              </div>
              <div class="flex items-center mb-4 gap-4">
                <svg
                  className="w-10 h-10 text-blue-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  <span className="font-[900]">
                    Profundiza en los conceptos y herramientas avanzadas
                  </span>{" "}
                  para analizar el mercado, gestionar el riesgo, tomar ganancias
                  y diversificar tu capital. Aprende a intercambiar tus
                  ganancias por otras monedas o criptomonedas.
                </span>
              </div>
              <div class="flex items-center mb-4 gap-4">
                <svg
                  className="w-10 h-10 text-blue-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  <span className="font-[900]">
                    Accede a una comunidad privada
                  </span>{" "}
                  donde podrás interactuar con otros alumnos, compartir
                  experiencias, resolver dudas, recibir apoyo, etc. Disfruta de
                  libros digitales con información y consejos sobre las opciones
                  binarias y el trading en general.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="resultados_section bg-primary py-12 px-4" id="resultados">
        <div class="flex flex-col items-center justify-center mb-14">
          <h2 class="text-white text-center text-4xl font-bold text-gray-800 mb-2">
            Resultados
          </h2>
          <svg
            className="w-16 h-16 text-blue-500 inline-block"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M12 2a3 3 0 0 0-2.1.9l-.9.9a1 1 0 0 1-.7.3H7a3 3 0 0 0-3 3v1.2c0 .3 0 .5-.2.7l-1 .9a3 3 0 0 0 0 4.2l1 .9c.2.2.3.4.3.7V17a3 3 0 0 0 3 3h1.2c.3 0 .5 0 .7.2l.9 1a3 3 0 0 0 4.2 0l.9-1c.2-.2.4-.3.7-.3H17a3 3 0 0 0 3-3v-1.2c0-.3 0-.5.2-.7l1-.9a3 3 0 0 0 0-4.2l-1-.9a1 1 0 0 1-.3-.7V7a3 3 0 0 0-3-3h-1.2a1 1 0 0 1-.7-.2l-.9-1A3 3 0 0 0 12 2Zm3.7 7.7a1 1 0 1 0-1.4-1.4L10 12.6l-1.3-1.3a1 1 0 0 0-1.4 1.4l2 2c.4.4 1 .4 1.4 0l5-5Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="max-w-[1500px] mx-auto grid grid-cols-2 md:grid-cols-5 gap-8">
          <img
            src={res1}
            class="hover:scale-105 transition duration-300 ease-in-out shadow-lg"
            alt="resultado1"
          ></img>
          <img
            src={res2}
            class="hover:scale-105 transition duration-300 ease-in-out shadow-lg"
            alt="resultado2"
          ></img>
          <img
            src={res3}
            class="hover:scale-105 transition duration-300 ease-in-out shadow-lg"
            alt="resultado3"
          ></img>
          <img
            src={res4}
            class="hover:scale-105 transition duration-300 ease-in-out shadow-lg"
            alt="resultado4"
          ></img>
          <img
            src={res5}
            class="hover:scale-105 transition duration-300 ease-in-out shadow-lg"
            alt="resultado5"
          ></img>
        </div>
      </div>
      <div class="faq_section bg-primary py-12 px-4" id="faq">
        <div class="flex flex-col items-center justify-center mx-auto w-full">
          <h2 class="text-center text-3xl font-bold text-white mb-8">
            Preguntas frecuentes
          </h2>
        </div>
        <div class="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          <div class="faq_item bg-black/10 p-2 rounded-lg">
            <h3 class="text-xl font-semibold text-white mb-4 hover:text-btnblue transition duration-300 ease-in-out cursor-default">
              ¿El acceso es por siempre?
            </h3>
            <p class="text-gray-400 hover:text-[18px] focus:text-[18px] transition-font-size duration-500 ease-in-out">
              Sí, una vez que adquieres el curso, tendrás acceso ilimitado a
              todo el contenido, incluyendo las actualizaciones y los recursos
              adicionales.
            </p>
          </div>
          <div class="faq_item bg-black/10 p-2 rounded-lg">
            <h3 class="text-xl font-semibold text-white mb-4 hover:text-btnblue transition duration-300 ease-in-out cursor-default">
              ¿Voy a aprender a operar con binarias?
            </h3>
            <p class="text-gray-400 hover:text-[18px] focus:text-[18px] transition-font-size duration-500 ease-in-out">
              Sí, el curso te enseñará todo lo que necesitas saber para operar
              con binarias de forma exitosa, desde los conceptos básicos hasta
              las estrategias avanzadas.
            </p>
          </div>
          <div class="faq_item bg-black/10 p-2 rounded-lg">
            <h3 class="text-xl font-semibold text-white mb-4 hover:text-btnblue transition duration-300 ease-in-out cursor-default">
              ¿Qué requisitos necesito para tomar el curso?
            </h3>
            <p class="text-gray-400 hover:text-[18px] focus:text-[18px] transition-font-size duration-500 ease-in-out">
              No necesitas ningún requisito previo para tomar el curso, solo
              necesitas tener una computadora con conexión a internet y muchas
              ganas de aprender.
            </p>
          </div>
          <div class="faq_item bg-black/10 p-2 rounded-lg">
            <h3 class="text-xl font-semibold text-white mb-4 hover:text-btnblue transition duration-300 ease-in-out cursor-default">
              ¿Qué plataforma de trading recomiendas?
            </h3>
            <p class="text-gray-400 hover:text-[18px] focus:text-[18px] transition-font-size duration-500 ease-in-out">
              Recomendamos usar Quotex, una plataforma de trading regulada y
              confiable, que ofrece una gran variedad de activos, herramientas y
              opciones de pago.
            </p>
          </div>
        </div>
      </div>
      <div class="contact_section bg-primary py-12 px-4">
        <h2 class="text-center text-3xl font-bold text-white mb-8">Contacto</h2>
        <div class="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center">
          <div class="contact_info mr-8 mb-4 md:mb-0 shadow-lg p-4 rounded-lg bg-black/10">
            <p class="text-[18px] text-gray-400">
              Si tienes alguna duda, sugerencia o comentario, puedes contactarme
              a través de los siguientes medios:
            </p>
            <ul class="text-gray-400 mt-4">
              <span class="flex items-center mb-2">
                <FaEnvelope size={24} color="#0d6efd" />
                <span class="ml-2">rentableinversor01@gmail.com</span>
              </span>
              <span class="flex items-center mb-2">
                <FaWhatsapp size={24} color="#0d6efd" />
                <span class="ml-2">+54 9 223 687-9502</span>
              </span>
              <span class="flex items-center mb-2">
                <FaInstagram size={24} color="#0d6efd" />
                <span class="ml-2">@rentableinversor</span>
              </span>
              <span class="flex items-center mb-2">
                <FaYoutube size={24} color="#0d6efd" />
                <span class="ml-2">@RentableInversor01</span>
              </span>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
